















import VueOptions from '@utils/VueOptions'
import CreateWizard from '@modules/ui/EventWizard/CreateWizard'
import SupplierSelector from '@superUI/Selectors/SupplierSelector'

settings =
  name: "EventCreate"
  components: { CreateWizard, SupplierSelector }
  resources:
    eventWizard:
      resourceName: "event_wizard"
      slug: "event_wizards/new"
      params:
        supplier_id: ":supplierId"
        organizer_id: ":organizerId"
  vue:
    data: ->
      anticipatedPage: 1
      page: 1
      selectedSupplierId: null
      showWizard: false

    mounted: ->
      @launchWizardIfSupplier()

    methods:
      setPage: (page) -> @page = page
      closeWizard: ->
        @$router.push({ name: 'EventListPage' })
        @showWizard = false
      saveWizard: (page) ->
        @anticipatedPage = page
        @anticipatedPage ||= @page
        @prime.eventWizard.supplier_id = @lookupSupplierId() if @lookupSupplierId()
        @prime.eventWizard.owner_id = @lookupOwnerId() if @lookupOwnerId()
        if @prime.eventWizard.name?
          @saveItem 'prime.eventWizard'
        else
          @onSave()
      onSave: (event) ->
        return @navToEdit(event) if @anticipatedPage > 2
        @closeWizard() if @anticipatedPage is -1
        @page = @anticipatedPage if @anticipatedPage < 3
      navToEdit: (event) ->
        @$router.push({ name: 'EventEditPage', params: { eventId: event.id }, query: { page: 2 } })

      createNextEvent: (event_set_id) ->
        @triggerResource 'eventWizard', "create_next_event", { event_set_id }

      onCreateNextEvent: (event) ->
        @navToEdit event

      hiSupplierSelected: (supplierId) ->
        @selectedSupplierId = supplierId
        @$router.push({ name: 'SupplierEventCreatePage', params: { supplierId } })

      launchWizardIfSupplier: ->
        @selectedSupplierId = @lookupSupplierId()
        return unless @selectedSupplierId
        @showWizard = true
        @fetch('eventWizard')

      lookupSupplierId: ->
        @$route.params.supplierId || @$route.query.supplierId

      lookupOwnerId: ->
        @$route.params.organizerId || @$route.query.organizerId

    watch:
      $route: ->
        @launchWizardIfSupplier()

export default VueOptions.vue settings
